// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-modules-Header-HeaderNav-NavDropdownFooter-style----general-module---footer---U5oPv width-100 display-flex justifyContent-center"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/HeaderNav/NavDropdownFooter/style/general.module.css
// module id = 1459
// module chunks = 168707334958949